import type React from 'react';
import { type SVGAttributes, useMemo } from 'react';
import styled from 'styled-components';

interface Props extends SVGAttributes<SVGSVGElement> {
  percent: number;
  radius: number;
}

const Circle = styled.circle`
  transition: all 0.3s ease;
`;

export const Gauge: React.FC<Props> = ({ percent = 10, radius, ...props }) => {
  const strokeWidth = useMemo(() => radius * 0.2, [radius]);
  const innerRadius = useMemo(() => radius - strokeWidth / 2, [radius, strokeWidth]);
  const circumference = useMemo(() => innerRadius * 2 * Math.PI, [innerRadius]);
  const arc = useMemo(() => circumference * 0.5, [circumference]);
  const dashArray = useMemo(() => `${arc} ${circumference}`, [arc, circumference]);
  const transform = useMemo(() => `rotate(180, ${radius}, ${radius})`, [radius]);
  const offset = useMemo(() => arc - (percent / 100) * arc, [percent, arc]);

  return (
    <svg height={radius * 2} width={radius * 2} {...props}>
      <Circle
        cx={radius}
        cy={radius}
        fill="transparent"
        r={innerRadius}
        stroke="white"
        strokeWidth={strokeWidth}
        strokeDasharray={dashArray}
        transform={transform}
        strokeLinecap="round"
      />
      <Circle
        cx={radius}
        cy={radius}
        fill="transparent"
        r={innerRadius}
        stroke="#CECECE"
        strokeDashoffset={offset}
        strokeDasharray={dashArray}
        strokeWidth={strokeWidth}
        transform={transform}
        strokeLinecap="round"
      />
    </svg>
  );
};
